import { useCallback } from 'react';

import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { useEzwmEnabledChecker } from '~legacy.personnel';

import { medicalDevicesTranslationKeys } from '../../translations';
import { MedicalDeviceAllFieldsFormController } from '../medicalDeviceOrder.types';
import { MedicalDeviceOrderNoNfzConfigurationModalContent } from '../MedicalDeviceOrderNoNfzConfigurationModalContent';

type MedicalDeviceOrderNfzConfigurationCheckEventInterceptorProps = Pick<
   MedicalDeviceAllFieldsFormController,
   'handleSubmit'
> & {
   readonly children: JSX.Element;
   readonly onPrintSuccess: VoidFunction;
   readonly printableWithoutVerification: boolean;
};

type ModalContentRendererProps = {
   reject: VoidFunction;
   closeModal: VoidFunction;
};

export const MedicalDeviceOrderNfzConfigurationCheckEventInterceptor = (
   props: MedicalDeviceOrderNfzConfigurationCheckEventInterceptorProps
): JSX.Element => {
   const ezwmEnabledChecker = useEzwmEnabledChecker();
   const shouldShowModal = async (): Promise<boolean> => {
      const ezwmEnabled = await ezwmEnabledChecker();
      return !ezwmEnabled;
   };
   const modalContentRenderer = useCallback(
      (rendererProps: ModalContentRendererProps) => (
         <MedicalDeviceOrderNoNfzConfigurationModalContent
            handleSubmit={props.handleSubmit}
            onCancel={rendererProps.reject}
            onClose={rendererProps.closeModal}
            onPrintSuccess={props.onPrintSuccess}
            printableWithoutVerification={props.printableWithoutVerification}
         />
      ),
      [props.handleSubmit, props.onPrintSuccess, props.printableWithoutVerification]
   );
   return (
      <ShowModalEventInterceptor
         testId={'nfzConfigurationCheck'}
         shouldShowModal={shouldShowModal}
         title={
            props.printableWithoutVerification
               ? medicalDevicesTranslationKeys.nfzConfigurationMissingModalTitleWithPrint
               : medicalDevicesTranslationKeys.nfzConfigurationMissingModalTitleWithoutPrint
         }
         content={modalContentRenderer}
         modalWidth={ModalWidth.WIDE}
         footerItemsHidden
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
